// utilities/mock/mockEventService.js
// Service for generating mock event data for testing and development

// Sample event data based on your provided files - exact data with no variations
const sampleEvents = [
  {
    event_name: "Component Click",
    event_type: "custom_event",
    event_direction: "inbound",
    timestamp: 1756404998645,
    device_id: "test-device-001",
    data: {
      // custom_event_type: "navigation",
      event_name: "Component Click",
      timestamp_unixtime_ms: "1756404998645",
      event_id: "8631361077435691440",
      source_message_id: "f68fb3ee-3eec-4bb0-3d34-6e64880a52e0",
      session_id: "8578207842180218170",
      session_uuid: "8CA8A689-2610-4DD5-4B70-BBA531B60B4B",
      session_start_unixtime_ms: "1756404995194",
      event_start_unixtime_ms: "0",
      custom_event_type: "navigation",
      custom_attributes: {
        order_status: "not started",
        screen: "restaurants: locator",
        screen_type: "restaurant",
        component_type: "button",
        component_variation: "large primary",
        visible_component_text: "use current location"
      },
      is_goal_defined: false,
      lifetime_value_change: 0,
      lifetime_value_attribute_name: null,
      data_connection_type: null,
      event_num: 0,
      view_controller: null,
      is_main_thread: null,
      canonical_name: null,
      event_system_notification_info: null,
      active_time_on_site_ms: "1826"
    }
  },
  {
    event_name: "eCommerce - Click",
    event_type: "commerce_event",
    event_direction: "inbound",
    timestamp: 1756405008462,
    device_id: "test-device-001",
    data: {
      product_action: {
        action: "click",
        checkout_step: 0,
        checkout_options: null,
        product_action_list: null,
        product_list_source: null,
        transaction_id: null,
        affiliation: null,
        total_amount: 0,
        tax_amount: 0,
        shipping_amount: 0,
        coupon_code: null,
        products: [
          {
            id: "1248",
            name: "4 st chili cheese tops",
            position: 0,
            price: 27,
            quantity: 1,
            total_product_amount: 27,
            custom_attributes: null
          }
        ]
      },
      promotion_action: null,
      product_impressions: null,
      shopping_cart: null,
      currency_code: null,
      screen_name: null,
      is_non_interactive: false,
      event_name: "eCommerce - Click",
      custom_event_type: "click",
      custom_flags: {},
      timestamp_unixtime_ms: "1756405008462",
      event_id: "5020854386763130913",
      source_message_id: "fab6256a-b66c-4218-0fe0-1859af57dc66",
      session_id: "8578207842180218170",
      session_uuid: "8CA8A689-2610-4DD5-4B70-BBA531B60B4B",
      session_start_unixtime_ms: "1756404995194",
      event_start_unixtime_ms: "0",
      custom_attributes: {
        component_type: "list item",
        component_variation: "meal price & calories",
        day_part: "null",
        event_position: "2/12",
        for_pickup_later: "null",
        order_status: "null",
        screen: "menu: category: sandwiches and meals",
        screen_type: "menu",
        visible_component_text: "4 st chili cheese tops",
      },
      is_goal_defined: false,
      lifetime_value_change: 0,
      lifetime_value_attribute_name: null,
      data_connection_type: null,
      event_num: 0,
      view_controller: null,
      is_main_thread: null,
      canonical_name: null,
      event_system_notification_info: null,
      active_time_on_site_ms: "11644"
    }
  },
  {
    event_name: "Meal Review Screen View",
    event_type: "screen_view",
    event_direction: "inbound",
    timestamp: 1756405019892,
    device_id: "test-device-001",
    data: {
      screen_name: "Meal Review Screen View",
      activity_type: null,
      custom_flags: {},
      timestamp_unixtime_ms: "1756405019892",
      event_id: "1151910275769732522",
      source_message_id: "f27e0d21-89eb-4645-b507-e013d2728110",
      session_id: "8578207842180218170",
      session_uuid: "8CA8A689-2610-4DD5-4B70-BBA531B60B4B",
      session_start_unixtime_ms: "1756404995194",
      event_start_unixtime_ms: "0",
      custom_attributes: {
        screen_type: "meal review",
        screen: "product: 6 st chicken mcnuggetsÂ® : meal details: meal review",
        screen_previous: "menu: category: snacks, sides & dips",
        product_selections: "none",
      },
      is_goal_defined: false,
      lifetime_value_change: 0,
      lifetime_value_attribute_name: null,
      data_connection_type: null,
      view_controller: null,
      is_main_thread: null,
      canonical_name: null,
      event_system_notification_info: null,
      active_time_on_site_ms: "23073"
    }
  },
  // Outbound beacon for Component Click (epsilon)
  {
    event_name: "send-navigation-event",
    event_direction: "outbound-epsilon",
    timestamp: 1756404998660, // 15ms after inbound (Component Click)
    device_id: "test-device-001",
    data: {
      event: {
        event_name: "Component Click",
        component_type: "button",
        session_id: "8578207842180218170",
        timestamp: "1756404998645",
        screen_type: "restaurant",
      },
      source_message_id: "out-epsilon-nav-001",
      event_id: "8631361077435691441",
      destination: "epsilon",
      status: "sent",
      response_time_ms: "45"
    }
  },
  // Outbound beacon for Product Click (kochava)
  {
    event_name: "track-product-click",
    event_direction: "outbound-kochava",
    timestamp: 1756405008485, // 23ms after inbound (eCommerce - Click)
    device_id: "test-device-001",
    data: {
      event: {
        action: "product_click",
        product_id: "1248",
        product_name: "big mac",
        product_price: "28",
        session_id: "8578207842180218170"
      },
      source_message_id: "out-kochava-prod-001",
      event_id: "5020854386763130914",
      destination: "kochava",
      status: "sent",
      response_time_ms: "72",
      kochava_device_id: "kochava_device_123456",
      kochava_app_id: "kom1234567890abcdef"
    }
  },
  // Outbound beacon for Screen View (epsilon)
  {
    event_name: "send-screen-view-data",
    event_direction: "outbound-epsilon",
    timestamp: 1756405019910, // 18ms after inbound (Meal Review Screen View)
    device_id: "test-device-001",
    data: {
      event: {
        screen_name: "Meal Review Screen View",
        product_id: "1200",
        product_name: "6 st chicken mcnuggets® ",
        screen_type: "meal review",
        order_status: "not started",
        session_id: "8578207842180218170",
        timestamp: "1756405019892"
      },
      source_message_id: "out-epsilon-screen-001",
      event_id: "1151910275769732523",
      destination: "epsilon",
      status: "sent",
      response_time_ms: "38",
      epsilon_profile_id: "epsilon_prof_987654"
    }
  },
  {
    event_name: "Test Extra Event",
    event_type: "custom_event",
    event_direction: "inbound",
    timestamp: 1756405019392,
    device_id: "test-device-001",
    data: {
      event_name: "Test Extra Event",
      custom_event_type: "test",
      timestamp_unixtime_ms: "1756405019692",
      event_id: "9999999999999999999",
      source_message_id: "extra-test-message-id",
      session_id: "8578207842180218170",
      session_uuid: "8CA8A689-2610-4DD5-4B70-BBA531B60B4B",
      session_start_unixtime_ms: "1756404995194",
      event_start_unixtime_ms: "0",
      custom_attributes: {
        test_attribute: "extra event value",
        screen_type: "test",
        component_type: "test_component"
      },
      is_goal_defined: false,
      lifetime_value_change: 0,
      data_connection_type: null,
      event_num: 0,
      active_time_on_site_ms: "30000"
    }
  }
];

/**
 * Generate mock event data for testing and development
 * @param {string} flowName - The name of the flow (currently unused)
 * @param {string|null} deviceId - Optional device ID to filter events
 * @returns {Array} Array of mock events sorted by timestamp
 */
export const generateMockEventData = (flowName, deviceId = null) => {
  let mockEvents = [...sampleEvents]; // Just use the exact events, no variations

  // Filter by device if specified
  if (deviceId && deviceId !== "None" && deviceId !== "") {
    mockEvents = mockEvents.filter(event => event.device_id === deviceId);
  }

  // Sort by timestamp
  mockEvents.sort((a, b) => a.timestamp - b.timestamp);

  return mockEvents;
};

const mockEventService = {
  generateMockEventData
};

export default mockEventService;